import { Flex, Table, TablePageSizeSelector, Text } from '@/components';
import { UserName } from '@/features/tenant-manager/user/_components/UserName';
import { useId } from '@/hooks';
import { ITEM_SPLITTER_COMMA } from '@/utils';
import { useTranslation } from 'react-i18next';
import { useUsersSnapshot } from '../_hooks/users-snapshot';
import { useUsersSnapshotQueryState } from '../_hooks/users-snapshot-query-state';
import { UsersTableSkeleton } from './UsersTableSkeleton';

export const UsersTable = () => {
  const { id } = useId();
  const { t } = useTranslation();
  const { searchQueryStates, setSearchQueryStates } =
    useUsersSnapshotQueryState();
  const users = useUsersSnapshot({ id, params: searchQueryStates });

  return users.isPending ? (
    <UsersTableSkeleton />
  ) : (
    <Flex vertical gap={24}>
      <Flex justify="flex-end">
        <TablePageSizeSelector
          defaultPageSize={searchQueryStates.pageSize}
          onChange={(pageSize) => {
            setSearchQueryStates((pre) => ({ ...pre, page: 1, pageSize }));
          }}
        />
      </Flex>
      <Table
        enableSticky
        dataSource={users.data?.results}
        pagination={{
          current: searchQueryStates.page,
          total: users.data?.count,
          showSizeChanger: false,
          pageSize: searchQueryStates.pageSize,
          onChange: (page, pageSize) => {
            setSearchQueryStates((pre) => ({ ...pre, page, pageSize }));
          },
        }}
        columns={[
          {
            title: t('name'),
            dataIndex: 'name',
            width: 300,
            render: (value, record) => (
              <UserName name={value} isIntegrated={record.isIntegrated} />
            ),
          },
          {
            title: t('email'),
            width: 300,
            dataIndex: 'email',
            render: (_, { email }) => <Text text={email} weight="regular" />,
          },
          {
            title: t('organization-name'),
            dataIndex: 'organizations',
            render: (_, record) =>
              record.organizations
                .map((org) => org.name)
                .join(ITEM_SPLITTER_COMMA),
          },
        ]}
      />
    </Flex>
  );
};
